function parseDate(input: string | number | Date): Date {
  if (typeof input === 'string') {
    return new Date(input);
  } else if (typeof input === 'number') {
    return new Date(input);
  } else if (input instanceof Date) {
    return input;
  }
  throw new Error('Invalid date input');
}

function normalizeDate(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/**
 *  Compare two dates
 * @param date1 - date1
 * @param date2 - date2
 * @returns  0 if the dates are equal, -1 if date1 is before date2, 1 if date1 is after date2
 */
export default function compareDates(date1: string | number | Date, date2: string | number | Date): number {
  const d1 = normalizeDate(parseDate(date1));
  const d2 = normalizeDate(parseDate(date2));
  
  if (d1.getTime() === d2.getTime()) {
    return 0; 
  } else if (d1.getTime() < d2.getTime()) {
    return -1; 
  } else {
    return 1;
  }
}